import AriticleForm from "../components/form/AriticleForm"
import useAuth from "../hooks/useAuth";
import { usePage } from "../contexts/PageProvider";
import axios from "../utils/axios";
import { CREATE_ARTICLE_URL } from '../contexts/PageProvider';
import {useNotifications} from 'reapop';

const submitUrl = '/article';

const CreateAritclePage = () => {
  const { pageData, setPageData } = usePage();
  const {notify} = useNotifications();

  if (pageData.url != CREATE_ARTICLE_URL) {
      setPageData({url: CREATE_ARTICLE_URL, title: "Fiche article"});      
  }
  
  const {auth} = useAuth();
  const userId = auth?.user?.id;
  
  const initialValues = {
    owner: userId,
    title: '',
    description: '',
    tags: '',
    image: '',
    content: '',
    is_active: true,
    display: [],
    group: ''
  };

  const onSubmit = async (values, {resetForm, setErrors, setSubmitting}) => {
    if (values.image) {
      values.image = JSON.stringify(values.image) // the image data is saved as a string
    }
    
    if (values.image_slider) {
      values.image_slider = JSON.stringify(values.image_slider)
    } 
    values.display = values.display.join(',')
    
    try {
      await axios.post(submitUrl, values);
      resetForm(); 
      notify('Article créé avec succès', 'info', {dismissAfter: 5000});
    } catch (error) {
      setErrors({createError: error.message})
      // console.error(error)
    }
  };

  return (
    <>
      <AriticleForm {...{initialValues, onSubmit, submitButtonChildren: 'Envoyer'}} />
    </>
  )
}

export default CreateAritclePage